import { useState } from "react";
import useAuthHttp from "./useAuthHttp";

export interface IFindDebentureResult {
    debenture_list: IDebentureList[]
}
  
export interface IDebentureList {
    id: string
    deb_code: string
    deb_company: string
    deb_situation: string
    deb_emit_date: string
    deb_due_date: string
    deb_profit_start_date: string
    deb_emission_value: number
    deb_index: string
    deb_reference_day_price_index: string
    deb_amort_each: string
    deb_amort_unity: string
    deb_amort_grace?: string
    deb_amort_type: string
    deb_interest_rate: number
    deb_interest_each: string
    deb_interest_unity: string
    deb_bank_agent: string
    deb_lead_coord: string
    pu_history?: IPuHistory[]
    debenture_event?: IDebentureEvent[]
}
  
export interface IPuHistory {
    pu_date: string
    pu_vl_nom: number
    pu_fee: number
    pu_prize: number
    pu_unit_price: number
    pu_calc_criteria: string
    pu_situation: string
}
  
export interface IDebentureEvent {
    event_date: string
    event_type: string
    event_fee?: number
}

export interface IDebentureSearch {
    id: string;
    code: string;
    cotation: { date: Date; value: number; }[];
    dueDate?: Date;
    index?: string;
    interestRate?: number;
}

export const useFindDebenture = () => {
    const { doGet } = useAuthHttp();
    const [debentureSearch, setDebentureSearch] = useState<IDebentureSearch[]>([]);
    const [loading, setLoading] = useState(false);
    
    const findDebentureByCode = async (code: string): Promise<void> => {
        try {
            if (!code || code.length < 2) {
                setDebentureSearch([]);
                return;
            }

            setLoading(true);
            const result = await doGet<IFindDebentureResult>(`/debenture/list?code=${code}`);
    
            setDebentureSearch(result?.debenture_list?.map(d => (
                { 
                    id: d.id,
                    code: d.deb_code, 
                    cotation: d.pu_history?.map(h => ({ date: new Date(h.pu_date), value: h.pu_unit_price })) ?? [],
                    dueDate: new Date(d.deb_due_date),
                    index: d.deb_index,
                    interestRate: d.deb_interest_rate
                })) ?? []);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    }

    return { findDebentureByCode, debentureSearch, setDebentureSearch, loadingDebenture: loading };
}
